import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Styles from "./ViewCustomerProduct.module.css";
import { ViewQrProductsService } from "../../../Services/ApiServices";
import emptyImg from "../../../Assets/no_image.svg";
import Loader from "../../../SharedComponents/Loader/Loader";
import NewStyles from "../Products/Confirmation.module.css";
import cancel from "../../../Assets/cross.png";

export default function ViewCustomerProduct(props) {
  let { id } = JSON.parse(sessionStorage.getItem("customerlog"));
  let location = useLocation();
  let isPath = location.pathname;
  const [selectedUnit, setselectedUnit] = useState({
    value: null,
    isError: false,
  });
  const [viewProductData, setViewProductData] = useState(null);
  const [productCount, setProductCount] = useState({
    count: 1,
    errorMsg: false,
  });
  const [isLoader, setIsLoader] = useState(false);
  const [submitCofirmation, setSubmitConfirmation] = useState(false);

  useEffect(() => {
    handleViewProduct();
  }, []);

  const handleViewProduct = () => {
    setIsLoader(true);
    let formData = new FormData();
    formData.append("franchise_id", id);
    formData.append("product_id", props.product_id);
    ViewQrProductsService(formData)
      .then((res) => {
        let tempProductDetails = { ...res.data };
        let tempImagesColors = [...tempProductDetails.product_images].map(
          (item, index) => {
            if (index === 0) {
              return { ...item, isActive: true };
            } else {
              return { ...item, isActive: false };
            }
          },
        );
        tempProductDetails = {
          ...tempProductDetails,
          product_images: tempImagesColors,
        };
        const productUnits = res.data.product_units ?? [];
        let defaultUnitData = productUnits[0];
        if (props.selectedProductUnitId) {
          defaultUnitData = productUnits.find(
            (item) => item.unit_id === props.selectedProductUnitId,
          );
        }

        setselectedUnit({
          isError: false,
          value: defaultUnitData ?? null,
        });

        const selectedProduct = props?.customerSelectedProducts?.find((ele) => {
          if (res.data.product_units?.length > 0) {
            return (
              ele?.product_id === res.data.product_id &&
              ele?.selectedUnit?.id === res.data.product_units[0]?.id
            );
          }
          return ele?.product_id === res.data.product_id;
        });

        setProductCount({
          count: selectedProduct
            ? selectedProduct?.selectedUnit?.qty || selectedProduct?.qty
            : res.data.product_units?.length > 0
              ? res.data.product_units[0]?.min_quantity || "1"
              : tempProductDetails.min_quantity || "1",
          isError: false,
          errorMsg: "",
        });

        const existingProduct = props?.customerSelectedProducts?.find(
          (ele) => ele?.product_id === tempProductDetails?.product_id,
        );

        if (existingProduct) {
          tempProductDetails = {
            ...tempProductDetails,
            product_units: tempProductDetails?.product_units?.map((val) => ({
              ...val,
              selected: existingProduct?.selectedUnit?.id === val?.id,
            })),
          };
        }

        setViewProductData(tempProductDetails);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const getButtonNameData = () => {
    const isAlreadyExist = props?.customerSelectedProducts?.some((e) => {
      if (selectedUnit?.value?.id) {
        return (
          e?.product_id === props?.product_id &&
          e?.selectedUnit?.id === selectedUnit?.value?.id
        );
      }

      return e?.product_id === props?.product_id;
    });

    return isAlreadyExist ? { id: 0, name: "Remove" } : { id: 1, name: "Add" };
  };

  const handlePressColor = (selectedItem) => {
    let tempProductDetails = { ...viewProductData };
    let alreadySelectedItem = [...tempProductDetails.product_images].find(
      (item) => item.isActive,
    );
    if (alreadySelectedItem.code !== selectedItem.code) {
      let tempImagesColors = [...tempProductDetails.product_images].map(
        (item) => {
          if (item.code === selectedItem.code) {
            return { ...item, isActive: true };
          } else {
            return { ...item, isActive: false };
          }
        },
      );
      tempProductDetails = {
        ...tempProductDetails,
        product_images: tempImagesColors,
      };
      setViewProductData(tempProductDetails);
    }
  };

  const getSelectedProductColorItem = () => {
    let tempProductDetails = { ...viewProductData };
    let selectedColorItem = tempProductDetails.product_images?.find(
      (item) => item.isActive,
    );
    return selectedColorItem;
  };

  const handleProductCount = (data) => {
    const minQty = selectedUnit?.value?.id
      ? selectedUnit?.value?.min_quantity || 1
      : viewProductData.min_quantity || 1;

    const maxQty = selectedUnit?.value?.id
      ? selectedUnit?.value?.quantity
      : viewProductData.quantity;

    if (data === "") {
      setProductCount((pre) => ({ ...pre, count: "", errorMsg: false }));
      return;
    }

    const qty = Number(data);

    if (isNaN(qty)) return;

    if (qty < minQty) {
      setProductCount({
        count: qty,
        isError: true,
        errorMsg: `Minimum quantity is ${minQty}`,
      });
    } else if (qty > maxQty) {
      setProductCount({
        count: qty,
        isError: true,
        errorMsg: `Maximum quantity is ${maxQty}`,
      });
    } else {
      setProductCount({
        count: qty,
        isError: false,
        errorMsg: "",
      });
    }
  };

  const handleClickAddRemove = () => {
    const buttonData = getButtonNameData();
    const minQty = selectedUnit?.value?.id
      ? selectedUnit?.value?.min_quantity || 1
      : viewProductData.min_quantity || 1;

    const maxQty = selectedUnit?.value?.id
      ? selectedUnit?.value?.quantity
      : viewProductData.quantity;

    const qty = Number(productCount?.count);

    if (buttonData.id === 1 && !qty) {
      setProductCount((pre) => ({
        ...pre,
        isError: true,
        errorMsg: "Enter quantity",
      }));
      return;
    }

    if (buttonData.id === 1 && qty < minQty) {
      setProductCount((pre) => ({
        ...pre,
        isError: true,
        errorMsg: `Minimum quantity is ${minQty}`,
      }));
      return;
    }

    if (buttonData.id === 1 && qty > maxQty) {
      setProductCount((pre) => ({
        ...pre,
        isError: true,
        errorMsg: `Maximum quantity is ${maxQty}`,
      }));
      return;
    }

    if (isPath.includes("/kansas_product")) {
      props?.handleSelectedData({
        ...viewProductData,
        qty: qty.toString(),
        selectedUnit: selectedUnit?.value
          ? {
              ...selectedUnit.value,
              qty,
            }
          : undefined,
        selling_price: selectedUnit?.value
          ? selectedUnit?.value?.selling_price || 0
          : viewProductData?.selling_price,
        colorItem: getSelectedProductColorItem(),
      });
    }
  };

  return (
    <div>
      <Loader isLoader={isLoader} />

      <Modal show={props.show} onHide={props.onHide} size="lg" centered>
        {viewProductData !== null ? (
          <Modal.Body>
            <div className={Styles.cancelImgParentContainer}>
              <div
                onClick={() => props.onHide()}
                className={Styles.cancelImgContainer}
              >
                x
              </div>
            </div>
            <div className={Styles.overallContainer}>
              <div className={Styles.LeftContainer}>
                {viewProductData.product_images?.length > 0 ? (
                  <Carousel
                    autoPlay={false}
                    autoPlaySpeed={5000}
                    arrows={true}
                    infinite={true}
                    responsive={responsive}
                    className="container"
                  >
                    {viewProductData?.product_images
                      .filter((item, index) => item.isActive)[0]
                      ?.image?.map((e, index) => (
                        <div key={index} className={Styles.imgContainer}>
                          <img src={e} alt="test" className={Styles.largeimg} />
                        </div>
                      ))}
                  </Carousel>
                ) : (
                  <img src={emptyImg} alt="empty" />
                )}
              </div>
              <div className={Styles.RightContainer}>
                <p className={Styles.details}>
                  <span className={Styles.productname}>
                    {viewProductData?.product_name}
                  </span>
                </p>
                <p className={Styles.price}>
                  ₹
                  {selectedUnit?.value
                    ? selectedUnit?.value?.selling_price?.toFixed(2) || 0.0
                    : viewProductData?.selling_price.toFixed(2)}{" "}
                  <span className={Styles.oldPrice}>
                    ₹
                    {selectedUnit?.value
                      ? selectedUnit?.value?.mrp_price?.toFixed(2) || 0.0
                      : viewProductData?.mrp_price.toFixed(2)}
                  </span>{" "}
                </p>
                <p className={Styles.productcode + " orange"}>
                  Product Code :{" "}
                  <span className={Styles.details1 + " text-black"}>
                    {viewProductData?.product_code}
                  </span>
                </p>
                <div className={Styles.unitButtonContainer}>
                  {viewProductData?.product_units &&
                    viewProductData?.product_units.length > 0 && (
                      <>
                        <div className="my-3">
                          <span className="modalHeading orange">Unit : </span>
                          <select
                            className={Styles.unitSelectContainer}
                            onChange={(e) => {
                              let tempSelectedUnit =
                                viewProductData?.product_units.find(
                                  (item) =>
                                    parseInt(item.id) ===
                                    parseInt(e.target.value),
                                );
                              if (tempSelectedUnit) {
                                setselectedUnit((pre) => ({
                                  ...pre,
                                  value: tempSelectedUnit,
                                  isError: false,
                                }));
                              } else {
                                setselectedUnit((pre) => ({
                                  ...pre,
                                  value: null,
                                  isError: true,
                                }));
                              }

                              setProductCount({
                                count: tempSelectedUnit?.min_quantity
                                  ? tempSelectedUnit?.min_quantity
                                  : "1",
                                isError: false,
                                errorMsg: "",
                              });
                            }}
                          >
                            {viewProductData?.product_units.map((item) => {
                              return (
                                <option
                                  selected={
                                    selectedUnit?.value?.unit_id ===
                                    item.unit_id
                                  }
                                  value={item.id}
                                >
                                  {item.unit_id}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {selectedUnit.isError ? (
                          <p className={Styles.errorMsg + " text-danger"}>
                            Select Valid Unit
                          </p>
                        ) : null}
                      </>
                    )}
                </div>
                <div>
                  <span className="modalHeading orange">Quantity : </span>
                  <input
                    className={Styles.productCount}
                    type="number"
                    value={productCount.count}
                    min={
                      selectedUnit?.value?.id
                        ? selectedUnit?.value?.min_quantity || 1
                        : viewProductData.min_quantity || 1
                    }
                    max={
                      selectedUnit?.value?.id
                        ? selectedUnit?.value?.quantity
                        : viewProductData.quantity
                    }
                    onChange={(e) => handleProductCount(e.target.value)}
                  />
                  <button
                    style={{
                      display: !isPath.includes("/kansas_product")
                        ? "none"
                        : null,
                    }}
                    onClick={() => {
                      handleClickAddRemove();
                    }}
                    className={Styles.customerAddBtn}
                  >
                    {selectedUnit?.value?.id
                      ? selectedUnit?.value?.quantity == 0
                        ? "Out of Stock"
                        : getButtonNameData().name
                      : viewProductData?.quantity == 0
                        ? "Out of Stock"
                        : getButtonNameData().name}
                  </button>
                </div>
                {productCount.isError || productCount.errorMsg ? (
                  <p className={Styles.errorMsg + " text-danger"}>
                    {productCount.errorMsg}
                  </p>
                ) : null}
                {viewProductData?.product_images.length > 0 && (
                  <p className="mt-2 mb-1">Color</p>
                )}
                {viewProductData?.product_images.length > 0 ? (
                  <div className="d-flex">
                    {viewProductData?.product_images?.map((item) => (
                      <div
                        onClick={() => {
                          handlePressColor(item);
                        }}
                        style={{
                          backgroundColor: item?.code,
                          border: item.isActive
                            ? "2px solid #ff7b26"
                            : "2px solid #000",
                        }}
                        className={Styles.color}
                      />
                    ))}
                  </div>
                ) : null}
                <p
                  className={Styles.details}
                  dangerouslySetInnerHTML={{
                    __html: viewProductData?.product_description,
                  }}
                />
              </div>
            </div>
          </Modal.Body>
        ) : null}
      </Modal>

      <Modal
        size="xs"
        show={submitCofirmation}
        onHide={props?.onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className={NewStyles.cancelImgParentContainer}>
            <div>
              <p className="fontBold">Confirmation</p>
            </div>
            <div className={NewStyles.cancelImgContainer}>
              <img
                onClick={() => setSubmitConfirmation(false)}
                src={cancel}
                alt="cancel"
                className={NewStyles.cancelImg}
              />
            </div>
          </div>
          <div className={NewStyles.container}>
            <p>
              Order quantity is lower than the minimum order quantity. Do you
              want to continue?
            </p>
          </div>

          <div className={NewStyles.btnContainer}>
            <button
              onClick={() => setSubmitConfirmation(false)}
              className={NewStyles.Resetbtn}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                props?.handleSelectedData({
                  ...viewProductData,
                  selectedUnit: selectedUnit.value,
                  selling_price: selectedUnit.value
                    ? selectedUnit?.value?.selling_price || 0
                    : viewProductData?.selling_price,
                  colorItem: getSelectedProductColorItem(),
                });
                setSubmitConfirmation(false);
                props.onHide();
              }}
              className={NewStyles.btn}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
